import React from "react";
import { Space, Title } from "react_reusable_components";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { ThreeRow } from "../../core/layouts";
import SetPassword from "../../components/SetPassword/SetPassword";
import CustomInput from "../../components/CustomInput/CustomInput";

const ResetPasswordFormModalContainerStyle = {
  middleSectionsTopSectionStyle: { marginBottom: variables.marginLarge },
  heading: {
    fontSize: variables.fontSizeNormal,
    fontWeight: variables.fontWeightBold,
    lineHeight: variables.lineHeightSmall,
    marginBottom: variables.marginXSmallest,
  },
};

export default function ResetPasswordFormModalContainer({
  myAccountResetPasswordFieldNames,
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
}) {
  const intl = useIntl();
  return (
    <ThreeRow
      topSection={
        <CustomInput
          name={myAccountResetPasswordFieldNames.OLD_PASSWORD}
          onChange={handleChange}
          onBlur={handleBlur}
          size={"small"}
          placeholder={getLocalizedMessage(
            intl,
            "account.label.Password.placeHolder"
          )}
          value={values[myAccountResetPasswordFieldNames.OLD_PASSWORD]}
          required
          label={getLocalizedMessage(intl, "account.label.Password")}
          isPassword
          error={
            touched[myAccountResetPasswordFieldNames.OLD_PASSWORD] &&
            errors[myAccountResetPasswordFieldNames.OLD_PASSWORD]
          }
        />
      }
      topSectionStyle={
        ResetPasswordFormModalContainerStyle.middleSectionsTopSectionStyle
      }
      middleSection={
        <Space size={0} direction={"vertical"}>
          <Title style={ResetPasswordFormModalContainerStyle.heading}>
            {getLocalizedMessage(intl, "login.createNewPassword")}
          </Title>
        </Space>
      }
      middleSectionStyle={{ marginBottom: variables.marginMedium }}
      bottomSection={
        <SetPassword
          size={"small"}
          values={values}
          fieldNames={myAccountResetPasswordFieldNames}
          errors={errors}
          handleChange={handleChange}
          handleBlur={handleBlur}
          labels={{
            [myAccountResetPasswordFieldNames.PASSWORD]: getLocalizedMessage(
              intl,
              "login.label.newPassword"
            ),
            [myAccountResetPasswordFieldNames.CONFIRM_PASSWORD]:
              getLocalizedMessage(intl, "login.label.confirmPassword"),
          }}
          placeholders={{
            [myAccountResetPasswordFieldNames.PASSWORD]: getLocalizedMessage(
              intl,
              "login.placeholder.newPassword"
            ),
            [myAccountResetPasswordFieldNames.CONFIRM_PASSWORD]:
              getLocalizedMessage(intl, "login.placeholder.confirmPassword"),
          }}
          touched={touched}
        />
      }
    />
  );
}
